import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import Vue from 'vue'

Vue.use(VueSweetalert2)
